var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarePrioritiesMental(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 261 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_105_35482",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 147
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.822 144.134C156.362 149.129 189.665 145.812 214.783 136.387C239.881 126.969 256.927 111.398 259.679 91.8162C262.431 72.2343 250.337 52.5681 228.807 36.5972C207.26 20.6134 176.162 8.24528 140.622 3.2504C105.081 -1.74447 71.7787 1.57272 46.6603 10.9981C21.5622 20.4158 4.51589 35.9867 1.76383 55.5685C-0.988218 75.1504 11.1058 94.8167 32.6358 110.788C54.1832 126.771 85.2813 139.139 120.822 144.134Z",
    fill: "#F5F9FE",
    stroke: "#E1E1E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_105_35482)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_105_35482)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.722,
    cy: 73.6924,
    rx: 129.725,
    ry: 70.6342,
    transform: "rotate(8 130.722 73.6924)",
    fill: "#F5F9FE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.4251 187.45C65.4251 187.45 31.4967 147.6 41.6599 137.405C51.8231 127.21 68.905 138.338 65.9783 126.974C63.0516 115.609 51.4007 104.588 56.1066 95.9611C61.762 85.6112 78.3132 94.0092 86.3271 97.6326C101.226 104.374 117.725 105.119 112.014 95.6954C106.302 86.2717 91.3134 77.0619 96.7445 71.6896C104.142 64.3801 144.802 91.4411 162.202 112.646C172.615 125.328 180.207 116.506 179.153 108.359C178.484 103.193 171.105 92.4927 178.842 87.659C186.318 82.9951 203.725 97.4407 209.642 106.363C225.139 129.719 199.767 187.239 199.767 187.239L65.4251 187.45Z",
    fill: "#C5CEDA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 16.2634,
    ry: 20.3642,
    transform: "matrix(0.143049 -0.989716 0.990227 0.139467 108.468 43.6584)",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.2003,
    ry: 16.1282,
    transform: "matrix(0.143049 -0.989716 0.990227 0.139467 123.467 32.4068)",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.333 48.888C155.72 59.9675 143.942 60.3513 129.947 60.6653C84.4253 61.6898 98.1454 51.8918 99.7519 40.8124C101.358 29.733 121.185 23.3479 135.08 25.2955C148.974 27.243 158.939 37.8086 157.333 48.888Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.563 44.0679C105.106 39.6129 109.765 36.6654 115.894 35.498C122.022 34.3305 128.138 38.0125 129.595 42.4707C131.052 46.9288 125.82 52.8976 120.294 50.0239C112.585 46.0179 108.016 48.5389 106.563 44.0679Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.898 49.8875C107.231 48.0358 109.692 45.9061 113.394 45.1477C117.096 44.3894 120.642 45.252 121.309 47.1037C121.976 48.9553 121.839 51.638 118.117 52.409C114.396 53.18 108.581 51.7423 107.898 49.8875Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.615 48.8079C113.359 45.1229 124.49 39.4856 130.515 38.287C136.539 37.0883 139.625 38.5127 138.016 41.4855C136.164 44.9162 134.083 50.4294 128.061 51.6313C122.04 52.8331 115.871 52.4929 114.615 48.8079Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.964 39.5393C130.964 43.3167 130.466 40.6185 124.272 40.6185C118.077 40.6185 108.537 43.3167 108.537 39.5393C108.537 35.7619 113.557 32.6966 119.749 32.6966C125.94 32.6966 130.964 35.7587 130.964 39.5393Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.682 40.9506C140.682 44.7454 135.668 47.8248 129.468 47.8248C123.269 47.8248 118.255 44.7454 118.255 40.9506C118.255 37.1558 123.788 38.6057 129.468 36.139C135.261 33.592 140.682 37.1558 140.682 40.9506Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.369 34.8444C125.519 33.4446 127.478 32.4979 129.744 32.7322C132.01 32.9666 133.722 34.2945 133.571 35.6911C133.42 37.0877 131.122 36.7909 128.856 36.5566C126.59 36.3222 125.215 36.2441 125.369 34.8444Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.957 85.7883C117.957 85.7883 108.033 83.0394 110.784 71.0771C113.535 59.1147 132.179 56.0042 136.5 70.0587C141.389 85.947 131.05 87.3565 117.957 85.7883Z",
    fill: "#555656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.985 132.553L148.046 187.184H149.893L136.758 132.553H131.985Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.19 132.553L99.1289 187.184H97.2861L110.417 132.553H115.19Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.59,
    cy: 122.24,
    rx: 29.656,
    ry: 29.2749,
    fill: "#000B64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.826 94.9132H118.742L119.538 84.9581H127.634L128.826 94.9132Z",
    fill: "#724C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.588 75.9845C133.588 83.2718 129.376 88.2236 124.18 88.2236C118.985 88.2236 114.772 84.471 114.772 75.9845C114.772 70.8553 118.984 66.6973 124.18 66.6973C129.376 66.6973 133.588 70.8553 133.588 75.9845Z",
    fill: "#855C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 112.405L148.735 114.74L135.493 101.669L140.602 96.6256L151.1 106.989C151.829 107.707 152.238 108.681 152.238 109.697C152.238 110.713 151.829 111.687 151.1 112.405Z",
    fill: "#855C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.969 108.506L146.6 106.54L134.373 122.675L137.973 126.513L149.47 114.041C150.148 113.242 150.476 112.209 150.382 111.171C150.288 110.133 149.78 109.174 148.969 108.506Z",
    fill: "#855C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11 121.974L95.1221 122.878L105.79 100.987L112.578 102.319L101.11 121.974Z",
    fill: "#855C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.191 182.739L108.033 183.402L98.7817 138.759L109.437 140.241L115.191 181.78V182.739Z",
    fill: "#658FDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.896 131.394L112.937 102.396L111.203 106.743L102.172 104.868L107.181 93.1458C107.955 91.3345 109.735 90.1411 111.726 90.098L119.201 89.9356C119.201 89.9356 120.618 94.0719 123.919 93.9944C127.283 93.9132 128.266 89.9356 128.266 89.9356H133.674C135.25 89.939 136.748 90.6111 137.786 91.7805L143.864 98.6251L138.257 105.448L133.607 102.551L136.971 129.745L110.896 131.394Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.157 141.349H102.441C100.343 141.349 98.6387 139.676 98.6284 137.604V134.553C98.6284 132.474 100.335 130.789 102.441 130.789L135.674 128.206C137.779 128.206 137.965 132.464 137.965 134.545V137.604C137.957 139.675 136.254 141.349 134.157 141.349Z",
    fill: "#658FDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.196 77.4567L114.772 72.232L118.742 63.1292L131.443 63.9484L135.196 77.4567Z",
    fill: "#555656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.996 141.349H134.157C134.157 141.349 137.521 141.29 137.965 137.589C137.965 137.589 139.386 130.391 136.781 128.199C136.16 127.675 122.547 128.937 114.963 129.675C113.693 129.798 112.539 130.456 111.797 131.48C111.055 132.505 110.797 133.796 111.09 135.021L112.585 141.357",
    fill: "#7AA0DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.972 135.301L120.409 182.955C120.409 182.955 126.053 182.955 127.208 182.955C128.363 182.955 127.973 181.702 127.973 181.702L120.996 141.349",
    fill: "#7AA0DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.4756,
    y: 124.044,
    width: 125.464,
    height: 7.57886,
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0171 187.461H68.6281L74.9637 130.405L75.3002 127.262H71.7754L67.0171 187.461Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.543 127.262L176.88 130.405L183.215 187.461H184.823L180.068 127.262H176.543Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7652 121.602C95.7652 121.602 94.2178 122.934 93.2422 125.686C92.7937 126.955 95.2719 129.313 98.1537 125.45C98.5948 124.86 99.1517 124.302 99.1592 125.037C99.1593 125.361 99.1292 125.685 99.0695 126.003C98.9804 126.349 99.0995 126.715 99.376 126.944C99.7274 127.162 100.707 127.114 100.804 125.177C100.991 121.295 101.383 121.391 101.383 121.391",
    fill: "#855C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.679 123.583C140.679 123.583 137.536 127.49 135.674 128.21C134.403 128.701 131.936 128.21 134.609 124.181C135.016 123.568 135.356 122.856 134.65 123.107C134.343 123.221 134.046 123.362 133.764 123.528C133.468 123.731 133.08 123.749 132.766 123.572C132.433 123.325 132.187 122.502 133.944 121.635C135.999 120.62 136.964 120.107 136.964 120.107",
    fill: "#855C55"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.28033,
    ry: 5.7,
    transform: "matrix(0.0549574 -0.998489 0.998565 0.0535578 124.003 60.1165)",
    fill: "#555656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.869 61.8452C118.869 61.8452 124.102 59.4099 129.308 61.8452",
    stroke: "#FDBE58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_105_35482",
    x: 1.87695,
    y: 1.43558,
    width: 257.689,
    height: 147.514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_105_35482"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_105_35482"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePrioritiesMental);
export default __webpack_public_path__ + "static/media/Care Priorities - Mental.301ba6089d5cd25e8a4de891ca7913e8.svg";
export { ForwardRef as ReactComponent };